import React, { useEffect, useRef, useState } from 'react';
import { getLogsConexao, limparLogsConexao, getStatus, getUsuarios, criarUsuario, atualizarUsuario, deletarUsuario, encerrarSessoes, getConfiguracoes, salvarConfiguracoes, getAuditoria } from '../services/api';

function formatarData(d) {
    if (!d) return '—';
    return new Date(d).toLocaleString('pt-BR');
}

function formatarUptime(segundos) {
    const h = Math.floor(segundos / 3600);
    const m = Math.floor((segundos % 3600) / 60);
    return `${h}h ${m}min`;
}

// ── Aba Status ────────────────────────────────────────────────

function AbaStatus() {
    const [status, setStatus] = useState(null);

    const carregar = async () => {
        try {
            const res = await getStatus();
            setStatus(res.data);
        } catch(e) { setStatus({ api: 'online', banco: 'offline' }); }
    };

    useEffect(() => { carregar(); const t = setInterval(carregar, 10000); return () => clearInterval(t); }, []);

    if (!status) return <div style={{ padding: 40, textAlign: 'center', color: 'var(--ios-gray)' }}>Carregando...</div>;

    const cards = [
        { label: 'Versão do sistema', valor: status.versao ? `v${status.versao}` : '—', cor: '#8e8e93' },
        { label: 'API', valor: status.api === 'online' ? 'Online' : 'Offline', cor: status.api === 'online' ? '#34c759' : '#ff3b30' },
        { label: 'Banco de dados', valor: status.banco === 'online' ? 'Online' : 'Offline', cor: status.banco === 'online' ? '#34c759' : '#ff3b30' },
        { label: 'Veículos ativos', valor: status.total_veiculos || 0, cor: '#007aff' },
        { label: 'Equipamentos', valor: status.total_equipamentos || 0, cor: '#5856d6' },
        { label: 'Total de posições', valor: Number(status.total_posicoes || 0).toLocaleString('pt-BR'), cor: '#ff9500' },
        { label: 'Última posição', valor: formatarData(status.ultima_posicao), cor: '#34c759' },
        { label: 'Uptime da API', valor: status.uptime ? formatarUptime(status.uptime) : '—', cor: '#007aff' },
    ];

    return (
        <div style={{ padding: 20 }}>
            <p style={{ fontSize: 12, color: 'var(--ios-gray)', textTransform: 'uppercase', letterSpacing: 0.5, margin: '0 4px 12px', fontWeight: 500 }}>Status em tempo real</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                {cards.map(c => (
                    <div key={c.label} style={{ background: 'white', borderRadius: 12, padding: '14px 18px', minWidth: 150, flex: 1, boxShadow: 'var(--ios-shadow)' }}>
                        <div style={{ fontSize: 20, fontWeight: 700, color: c.cor, letterSpacing: -0.5 }}>{c.valor}</div>
                        <div style={{ fontSize: 11, color: 'var(--ios-gray)', marginTop: 4, fontWeight: 500 }}>{c.label}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}

// ── Aba Logs ──────────────────────────────────────────────────

function AbaLogs() {
    const [logs, setLogs] = useState([]);
    const [carregando, setCarregando] = useState(true);

    const carregar = async () => {
        try {
            const res = await getLogsConexao();
            setLogs(res.data);
        } catch(e) {} finally { setCarregando(false); }
    };

    const limpar = async () => {
        await limparLogsConexao();
        setLogs([]);
    };

    useEffect(() => { carregar(); const t = setInterval(carregar, 15000); return () => clearInterval(t); }, []);

    return (
        <div style={{ padding: 20 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <p style={{ fontSize: 12, color: 'var(--ios-gray)', textTransform: 'uppercase', letterSpacing: 0.5, margin: 0, fontWeight: 500 }}>
                    IMEIs não cadastrados — {logs.length} registro{logs.length !== 1 ? 's' : ''}
                </p>
                {logs.length > 0 && (
                    <button onClick={limpar} className="ios-btn ios-btn-sm" style={{ background: 'rgba(255,59,48,0.1)', color: '#ff3b30' }}>
                        Limpar logs
                    </button>
                )}
            </div>

            {carregando ? (
                <div style={{ textAlign: 'center', color: 'var(--ios-gray)', padding: 40 }}>Carregando...</div>
            ) : logs.length === 0 ? (
                <div style={{ textAlign: 'center', color: 'var(--ios-gray)', padding: 60 }}>
                    <div style={{ fontSize: 36, opacity: 0.3, marginBottom: 10 }}>✅</div>
                    <div style={{ fontSize: 15, fontWeight: 500 }}>Nenhuma tentativa não autorizada</div>
                    <div style={{ fontSize: 13, marginTop: 4 }}>Todos os IMEIs conectados estão cadastrados</div>
                </div>
            ) : (
                <div style={{ background: 'white', borderRadius: 12, overflow: 'hidden', boxShadow: 'var(--ios-shadow)' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                        <thead>
                            <tr style={{ background: 'var(--ios-gray6)', borderBottom: '1px solid var(--ios-separator)' }}>
                                {['IMEI', 'IP de Origem', 'Motivo', 'Tentativas', 'Primeira', 'Última tentativa'].map((h, i) => (
                                    <th key={h} style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, fontSize: 11, color: 'var(--ios-gray)', textTransform: 'uppercase', letterSpacing: 0.4, whiteSpace: 'nowrap' }}>{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {logs.map((l, i) => (
                                <tr key={l.id} style={{ borderBottom: '1px solid var(--ios-separator)', background: 'white' }}
                                    onMouseEnter={e => e.currentTarget.style.background = 'var(--ios-gray6)'}
                                    onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                                    <td style={{ padding: '10px 14px', fontFamily: 'monospace', fontWeight: 600, color: '#ff3b30' }}>{l.imei}</td>
                                    <td style={{ padding: '10px 14px', fontFamily: 'monospace', fontSize: 12, color: 'var(--ios-label2)' }}>{l.ip}</td>
                                    <td style={{ padding: '10px 14px', color: 'var(--ios-gray)' }}>{l.motivo}</td>
                                    <td style={{ padding: '10px 14px', textAlign: 'center' }}>
                                        <span style={{ background: 'rgba(255,59,48,0.1)', color: '#ff3b30', borderRadius: 20, padding: '2px 10px', fontWeight: 700, fontSize: 12 }}>
                                            {l.tentativas}
                                        </span>
                                    </td>
                                    <td style={{ padding: '10px 14px', fontSize: 12, color: 'var(--ios-label2)', whiteSpace: 'nowrap' }}>{formatarData(l.primeira_tentativa)}</td>
                                    <td style={{ padding: '10px 14px', fontSize: 12, color: 'var(--ios-label2)', whiteSpace: 'nowrap' }}>{formatarData(l.ultima_tentativa)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

// ── Aba Usuários ──────────────────────────────────────────────

function IosField({ label, children }) {
    return (
        <div style={{ borderBottom: '1px solid var(--ios-separator)' }}>
            <div style={{ padding: '0 16px' }}>
                <span style={{ fontSize: 11, color: 'var(--ios-gray)', fontWeight: 500, textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', paddingTop: 9 }}>{label}</span>
                {children}
            </div>
        </div>
    );
}

const inputStyle = {
    width: '100%', border: 'none', outline: 'none', fontSize: 15,
    fontFamily: 'var(--ios-font)', color: 'var(--ios-label)',
    background: 'transparent', padding: '8px 0 10px', boxSizing: 'border-box',
};

function ModalUsuario({ usuario, onSalvar, onFechar }) {
    const [form, setForm] = useState({ nome: usuario?.nome || '', email: usuario?.email || '', senha: '', perfil: usuario?.perfil || 'user' });
    const [erro, setErro] = useState('');
    const [salvando, setSalvando] = useState(false);
    const set = campo => e => setForm(f => ({ ...f, [campo]: e.target.value }));

    const salvar = async () => {
        setErro(''); setSalvando(true);
        try {
            usuario ? await atualizarUsuario(usuario.id, form) : await criarUsuario(form);
            onSalvar();
        } catch(e) { setErro(e.response?.data?.erro || 'Erro ao salvar'); }
        finally { setSalvando(false); }
    };

    return (
        <div className="ios-overlay" onClick={onFechar}>
            <div className="ios-sheet" style={{ width: 380, maxWidth: '95vw' }} onClick={e => e.stopPropagation()}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid var(--ios-separator)' }}>
                    <button onClick={onFechar} style={{ background: 'none', border: 'none', color: '#ff3b30', fontSize: 15, cursor: 'pointer', fontFamily: 'var(--ios-font)' }}>Cancelar</button>
                    <span style={{ fontWeight: 600, fontSize: 16 }}>{usuario ? 'Editar Usuário' : 'Novo Usuário'}</span>
                    <button onClick={salvar} disabled={salvando} style={{ background: 'none', border: 'none', color: '#007aff', fontSize: 15, fontWeight: 600, cursor: 'pointer', fontFamily: 'var(--ios-font)' }}>
                        {salvando ? '...' : 'Salvar'}
                    </button>
                </div>
                <div style={{ padding: '20px 16px', background: 'var(--ios-gray6)' }}>
                    <div className="ios-group" style={{ marginBottom: 16 }}>
                        <IosField label="Nome completo"><input style={inputStyle} placeholder="João Silva" value={form.nome} onChange={set('nome')} /></IosField>
                        <IosField label="Email"><input style={inputStyle} type="email" placeholder="joao@email.com" value={form.email} onChange={set('email')} /></IosField>
                        <IosField label={usuario ? 'Nova senha (deixe em branco para manter)' : 'Senha'}>
                            <input style={inputStyle} type="password" placeholder="••••••••" value={form.senha} onChange={set('senha')} />
                        </IosField>
                    </div>
                    <div className="ios-group">
                        {['user', 'admin'].map((p, i) => (
                            <div key={p} onClick={() => setForm(f => ({ ...f, perfil: p }))}
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '13px 16px', cursor: 'pointer', background: 'white', borderBottom: i === 0 ? '1px solid var(--ios-separator)' : 'none' }}>
                                <div>
                                    <div style={{ fontSize: 15, color: 'var(--ios-label)' }}>{p === 'admin' ? 'Admin' : 'User'}</div>
                                    <div style={{ fontSize: 12, color: 'var(--ios-gray)', marginTop: 1 }}>{p === 'admin' ? 'Acesso total ao sistema' : 'Somente visualização'}</div>
                                </div>
                                {form.perfil === p && <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17l-5-5" stroke="#007aff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>}
                            </div>
                        ))}
                    </div>
                    {erro && <div style={{ marginTop: 12, background: 'rgba(255,59,48,0.08)', borderRadius: 10, padding: '10px 14px', color: '#ff3b30', fontSize: 13 }}>{erro}</div>}
                </div>
            </div>
        </div>
    );
}

function AbaUsuarios() {
    const [usuarios, setUsuarios] = useState([]);
    const [editando, setEditando] = useState(null);
    const [novo, setNovo] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(null);
    const [confirmSessao, setConfirmSessao] = useState(null);
    const [msgSessao, setMsgSessao] = useState('');

    const carregar = async () => { const res = await getUsuarios(); setUsuarios(res.data); };
    useEffect(() => { carregar(); }, []);

    const excluir = async (id) => { await deletarUsuario(id); setConfirmDelete(null); carregar(); };

    const encerrarSessao = async (id) => {
        await encerrarSessoes(id);
        setConfirmSessao(null);
        setMsgSessao('Sessões encerradas — o usuário precisará logar novamente.');
        setTimeout(() => setMsgSessao(''), 4000);
    };

    return (
        <div style={{ padding: 20 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <p style={{ fontSize: 12, color: 'var(--ios-gray)', textTransform: 'uppercase', letterSpacing: 0.5, margin: 0, fontWeight: 500 }}>Usuários do sistema</p>
                <button className="ios-btn ios-btn-primary ios-btn-sm" onClick={() => setNovo(true)}>+ Novo</button>
            </div>
            {usuarios.length === 0 ? (
                <div style={{ textAlign: 'center', color: 'var(--ios-gray)', padding: 40 }}>Nenhum usuário cadastrado</div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 1, borderRadius: 12, overflow: 'hidden', boxShadow: 'var(--ios-shadow)' }}>
                    {usuarios.map((u, i) => (
                        <div key={u.id} style={{ background: 'white', padding: '13px 16px', display: 'flex', alignItems: 'center', gap: 12, borderBottom: i < usuarios.length - 1 ? '1px solid var(--ios-separator)' : 'none' }}>
                            <div style={{ width: 38, height: 38, borderRadius: '50%', flexShrink: 0, background: u.perfil === 'admin' ? 'rgba(255,149,0,0.15)' : 'rgba(0,122,255,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, fontWeight: 600, color: u.perfil === 'admin' ? '#e08600' : '#007aff' }}>
                                {u.nome?.charAt(0).toUpperCase()}
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ fontWeight: 500, fontSize: 15, color: 'var(--ios-label)' }}>{u.nome}</div>
                                <div style={{ fontSize: 12, color: 'var(--ios-gray)', marginTop: 1 }}>{u.email}</div>
                            </div>
                            <span style={{ fontSize: 11, fontWeight: 600, borderRadius: 20, padding: '3px 9px', background: u.perfil === 'admin' ? 'rgba(255,149,0,0.13)' : 'rgba(52,199,89,0.13)', color: u.perfil === 'admin' ? '#e08600' : '#28a745' }}>
                                {u.perfil === 'admin' ? 'Admin' : 'User'}
                            </span>
                            <button className="ios-btn ios-btn-gray ios-btn-sm" onClick={() => setConfirmSessao(u)}>Encerrar sessões</button>
                            <button className="ios-btn ios-btn-gray ios-btn-sm" onClick={() => setEditando(u)}>Editar</button>
                            <button className="ios-btn ios-btn-sm" style={{ background: 'rgba(255,59,48,0.1)', color: '#ff3b30' }} onClick={() => setConfirmDelete(u)}>Excluir</button>
                        </div>
                    ))}
                </div>
            )}

            {msgSessao && (
                <div style={{ marginTop: 12, background: 'rgba(52,199,89,0.1)', borderRadius: 10, padding: '10px 14px', color: '#248a3d', fontSize: 13 }}>
                    {msgSessao}
                </div>
            )}

            {(novo || editando) && <ModalUsuario usuario={editando} onSalvar={() => { setNovo(false); setEditando(null); carregar(); }} onFechar={() => { setNovo(false); setEditando(null); }} />}

            {confirmSessao && (
                <div className="ios-overlay">
                    <div className="ios-sheet" style={{ width: 320, overflow: 'hidden' }} onClick={e => e.stopPropagation()}>
                        <div style={{ padding: '24px 20px 8px', textAlign: 'center' }}>
                            <div style={{ fontWeight: 600, fontSize: 17, marginBottom: 6 }}>Encerrar Sessões</div>
                            <div style={{ fontSize: 14, color: 'var(--ios-gray)', marginBottom: 20 }}>
                                Isso vai desconectar <strong>{confirmSessao.nome}</strong> de todos os dispositivos onde já estiver logado, inclusive sessões com "permanecer conectado" ativo. Confirma?
                            </div>
                        </div>
                        <div style={{ borderTop: '1px solid var(--ios-separator)', display: 'flex' }}>
                            <button onClick={() => setConfirmSessao(null)} style={{ flex: 1, padding: 14, border: 'none', borderRight: '1px solid var(--ios-separator)', background: 'white', fontSize: 16, color: '#007aff', cursor: 'pointer', fontFamily: 'var(--ios-font)' }}>Cancelar</button>
                            <button onClick={() => encerrarSessao(confirmSessao.id)} style={{ flex: 1, padding: 14, border: 'none', background: 'white', fontSize: 16, color: '#ff3b30', fontWeight: 600, cursor: 'pointer', fontFamily: 'var(--ios-font)' }}>Encerrar</button>
                        </div>
                    </div>
                </div>
            )}

            {confirmDelete && (
                <div className="ios-overlay">
                    <div className="ios-sheet" style={{ width: 300, overflow: 'hidden' }} onClick={e => e.stopPropagation()}>
                        <div style={{ padding: '24px 20px 8px', textAlign: 'center' }}>
                            <div style={{ fontWeight: 600, fontSize: 17, marginBottom: 6 }}>Excluir Usuário</div>
                            <div style={{ fontSize: 14, color: 'var(--ios-gray)', marginBottom: 20 }}>Deseja excluir <strong>{confirmDelete.nome}</strong>?</div>
                        </div>
                        <div style={{ borderTop: '1px solid var(--ios-separator)', display: 'flex' }}>
                            <button onClick={() => setConfirmDelete(null)} style={{ flex: 1, padding: 14, border: 'none', borderRight: '1px solid var(--ios-separator)', background: 'white', fontSize: 16, color: '#007aff', cursor: 'pointer', fontFamily: 'var(--ios-font)' }}>Cancelar</button>
                            <button onClick={() => excluir(confirmDelete.id)} style={{ flex: 1, padding: 14, border: 'none', background: 'white', fontSize: 16, color: '#ff3b30', fontWeight: 600, cursor: 'pointer', fontFamily: 'var(--ios-font)' }}>Excluir</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

// ── Aba Auditoria ─────────────────────────────────────────────

const ACOES = {
    consulta_historico: { label: 'Consulta de histórico', cor: '#007aff', icone: '🔍' },
    exclusao_veiculo:   { label: 'Exclusão de veículo',   cor: '#ff3b30', icone: '🗑' },
};

function AbaAuditoria() {
    const [logs, setLogs] = useState([]);
    const [carregando, setCarregando] = useState(true);
    const [filtroUsuario, setFiltroUsuario] = useState('');
    const [filtroAcao, setFiltroAcao] = useState('');
    const [filtroInicio, setFiltroInicio] = useState('');
    const [filtroFim, setFiltroFim] = useState('');

    const carregar = async () => {
        setCarregando(true);
        try {
            const params = {};
            if (filtroUsuario) params.usuario = filtroUsuario;
            if (filtroAcao)    params.acao = filtroAcao;
            if (filtroInicio)  params.inicio = new Date(filtroInicio).toISOString();
            if (filtroFim)     params.fim = new Date(filtroFim).toISOString();
            const res = await getAuditoria(params);
            setLogs(res.data);
        } catch(e) {} finally { setCarregando(false); }
    };

    useEffect(() => { carregar(); }, []);

    return (
        <div style={{ padding: 20 }}>
            {/* Filtros */}
            <div style={{ background: 'white', borderRadius: 12, padding: '14px 16px', marginBottom: 16, boxShadow: 'var(--ios-shadow)' }}>
                <div style={{ fontSize: 12, color: 'var(--ios-gray)', textTransform: 'uppercase', letterSpacing: 0.5, fontWeight: 500, marginBottom: 12 }}>Filtros</div>
                <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'flex-end' }}>
                    <div style={{ flex: 1, minWidth: 140 }}>
                        <div style={{ fontSize: 11, color: 'var(--ios-gray)', fontWeight: 500, marginBottom: 4 }}>Usuário</div>
                        <input value={filtroUsuario} onChange={e => setFiltroUsuario(e.target.value)}
                            placeholder="Nome..." style={{ width: '100%', border: '1px solid var(--ios-separator)', borderRadius: 8, padding: '7px 10px', fontSize: 13, fontFamily: 'var(--ios-font)', outline: 'none', boxSizing: 'border-box' }} />
                    </div>
                    <div style={{ flex: 1, minWidth: 160 }}>
                        <div style={{ fontSize: 11, color: 'var(--ios-gray)', fontWeight: 500, marginBottom: 4 }}>Tipo de ação</div>
                        <select value={filtroAcao} onChange={e => setFiltroAcao(e.target.value)}
                            style={{ width: '100%', border: '1px solid var(--ios-separator)', borderRadius: 8, padding: '7px 10px', fontSize: 13, fontFamily: 'var(--ios-font)', outline: 'none', background: 'white', boxSizing: 'border-box' }}>
                            <option value="">Todas</option>
                            {Object.entries(ACOES).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
                        </select>
                    </div>
                    <div style={{ flex: 1, minWidth: 160 }}>
                        <div style={{ fontSize: 11, color: 'var(--ios-gray)', fontWeight: 500, marginBottom: 4 }}>De</div>
                        <input type="datetime-local" value={filtroInicio} onChange={e => setFiltroInicio(e.target.value)}
                            style={{ width: '100%', border: '1px solid var(--ios-separator)', borderRadius: 8, padding: '7px 10px', fontSize: 13, fontFamily: 'var(--ios-font)', outline: 'none', boxSizing: 'border-box' }} />
                    </div>
                    <div style={{ flex: 1, minWidth: 160 }}>
                        <div style={{ fontSize: 11, color: 'var(--ios-gray)', fontWeight: 500, marginBottom: 4 }}>Até</div>
                        <input type="datetime-local" value={filtroFim} onChange={e => setFiltroFim(e.target.value)}
                            style={{ width: '100%', border: '1px solid var(--ios-separator)', borderRadius: 8, padding: '7px 10px', fontSize: 13, fontFamily: 'var(--ios-font)', outline: 'none', boxSizing: 'border-box' }} />
                    </div>
                    <button className="ios-btn ios-btn-primary ios-btn-sm" onClick={carregar} style={{ flexShrink: 0 }}>Filtrar</button>
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                <p style={{ fontSize: 12, color: 'var(--ios-gray)', textTransform: 'uppercase', letterSpacing: 0.5, margin: 0, fontWeight: 500 }}>
                    {logs.length} registro{logs.length !== 1 ? 's' : ''} encontrado{logs.length !== 1 ? 's' : ''}
                </p>
            </div>

            {carregando ? (
                <div style={{ textAlign: 'center', color: 'var(--ios-gray)', padding: 40 }}>Carregando...</div>
            ) : logs.length === 0 ? (
                <div style={{ textAlign: 'center', color: 'var(--ios-gray)', padding: 60 }}>
                    <div style={{ fontSize: 36, opacity: 0.3, marginBottom: 10 }}>📋</div>
                    <div style={{ fontSize: 15, fontWeight: 500 }}>Nenhum registro encontrado</div>
                </div>
            ) : (
                <div style={{ background: 'white', borderRadius: 12, overflow: 'hidden', boxShadow: 'var(--ios-shadow)' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                        <thead>
                            <tr style={{ background: 'var(--ios-gray6)', borderBottom: '1px solid var(--ios-separator)' }}>
                                {['Data/Hora', 'Usuário', 'Ação', 'Detalhes', 'IP'].map(h => (
                                    <th key={h} style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 600, fontSize: 11, color: 'var(--ios-gray)', textTransform: 'uppercase', letterSpacing: 0.4, whiteSpace: 'nowrap' }}>{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {logs.map((l, i) => {
                                const cfg = ACOES[l.acao] || { label: l.acao, cor: '#636366', icone: '•' };
                                return (
                                    <tr key={l.id} style={{ borderBottom: '1px solid var(--ios-separator)', background: 'white' }}
                                        onMouseEnter={e => e.currentTarget.style.background = 'var(--ios-gray6)'}
                                        onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                                        <td style={{ padding: '10px 12px', whiteSpace: 'nowrap', color: 'var(--ios-label2)' }}>
                                            {new Date(l.criado_em).toLocaleString('pt-BR')}
                                        </td>
                                        <td style={{ padding: '10px 12px', fontWeight: 500, color: 'var(--ios-label)' }}>
                                            {l.usuario_nome || '—'}
                                        </td>
                                        <td style={{ padding: '10px 12px' }}>
                                            <span style={{ background: `${cfg.cor}18`, color: cfg.cor, borderRadius: 6, padding: '3px 8px', fontWeight: 600, fontSize: 11, whiteSpace: 'nowrap' }}>
                                                {cfg.icone} {cfg.label}
                                            </span>
                                        </td>
                                        <td style={{ padding: '10px 12px', color: 'var(--ios-label2)', maxWidth: 300 }}>
                                            {l.detalhes}
                                        </td>
                                        <td style={{ padding: '10px 12px', fontFamily: 'monospace', fontSize: 11, color: 'var(--ios-gray)' }}>
                                            {l.ip || '—'}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

// ── Aba Customização ──────────────────────────────────────────

function AbaCustomizacao({ onAtualizar }) {
    const [nome, setNome] = useState('');
    const [logo, setLogo] = useState(null);
    const [preview, setPreview] = useState(null);
    const [trailLength, setTrailLength] = useState(2);
    const [salvando, setSalvando] = useState(false);
    const [msg, setMsg] = useState('');
    const inputFile = useRef(null);

    useEffect(() => {
        getConfiguracoes().then(res => {
            setNome(res.data.nome_plataforma || 'Sigatron');
            if (res.data.logo_base64) { setLogo(res.data.logo_base64); setPreview(res.data.logo_base64); }
            setTrailLength(res.data.trail_length ?? 2);
        }).catch(() => {});
    }, []);

    const escolherImagem = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (ev) => { setLogo(ev.target.result); setPreview(ev.target.result); };
        reader.readAsDataURL(file);
    };

    const removerLogo = () => { setLogo(null); setPreview(null); if (inputFile.current) inputFile.current.value = ''; };

    const salvar = async () => {
        setSalvando(true); setMsg('');
        try {
            await salvarConfiguracoes({ nome_plataforma: nome, logo_base64: logo, trail_length: trailLength });
            setMsg('Salvo com sucesso!');
            if (onAtualizar) onAtualizar();
        } catch(e) { setMsg('Erro ao salvar'); }
        finally { setSalvando(false); setTimeout(() => setMsg(''), 3000); }
    };

    return (
        <div style={{ padding: 24, maxWidth: 520 }}>
            <p style={{ fontSize: 12, color: 'var(--ios-gray)', textTransform: 'uppercase', letterSpacing: 0.5, margin: '0 4px 16px', fontWeight: 500 }}>
                Identidade visual da plataforma
            </p>

            {/* Nome */}
            <div className="ios-group" style={{ marginBottom: 20 }}>
                <div style={{ borderBottom: '1px solid var(--ios-separator)' }}>
                    <div style={{ padding: '0 16px' }}>
                        <span style={{ fontSize: 11, color: 'var(--ios-gray)', fontWeight: 500, textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', paddingTop: 9 }}>Nome da plataforma</span>
                        <input
                            style={{ width: '100%', border: 'none', outline: 'none', fontSize: 15, fontFamily: 'var(--ios-font)', color: 'var(--ios-label)', background: 'transparent', padding: '8px 0 10px', boxSizing: 'border-box' }}
                            value={nome}
                            onChange={e => setNome(e.target.value)}
                            placeholder="Ex: Sigatron"
                        />
                    </div>
                </div>
            </div>

            {/* Logo */}
            <div style={{ background: 'white', borderRadius: 14, padding: 20, boxShadow: 'var(--ios-shadow)', marginBottom: 20 }}>
                <div style={{ fontSize: 12, color: 'var(--ios-gray)', textTransform: 'uppercase', letterSpacing: 0.5, fontWeight: 500, marginBottom: 14 }}>
                    Logo / Ícone
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                    {/* Preview */}
                    <div style={{
                        width: 72, height: 72, borderRadius: 14, flexShrink: 0,
                        background: preview ? 'transparent' : 'var(--ios-gray6)',
                        border: '2px dashed var(--ios-separator)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden',
                    }}>
                        {preview ? (
                            <img src={preview} alt="logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                        ) : (
                            <span style={{ fontSize: 28, opacity: 0.3 }}>🖼</span>
                        )}
                    </div>

                    <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 13, color: 'var(--ios-label)', marginBottom: 6 }}>
                            {preview ? 'Logo carregado' : 'Nenhum logo definido'}
                        </div>
                        <div style={{ fontSize: 12, color: 'var(--ios-gray)', marginBottom: 12 }}>
                            PNG, JPG ou SVG. Será usado na navbar, favicon e relatórios.
                        </div>
                        <div style={{ display: 'flex', gap: 8 }}>
                            <button className="ios-btn ios-btn-primary ios-btn-sm" onClick={() => inputFile.current?.click()}>
                                {preview ? 'Trocar' : 'Escolher imagem'}
                            </button>
                            {preview && (
                                <button className="ios-btn ios-btn-sm" style={{ background: 'rgba(255,59,48,0.1)', color: '#ff3b30' }} onClick={removerLogo}>
                                    Remover
                                </button>
                            )}
                        </div>
                        <input ref={inputFile} type="file" accept="image/*" style={{ display: 'none' }} onChange={escolherImagem} />
                    </div>
                </div>
            </div>

            {/* Nota sobre uso */}
            <div style={{ background: 'rgba(0,122,255,0.06)', borderRadius: 10, padding: '12px 14px', marginBottom: 20, fontSize: 12, color: '#007aff' }}>
                O logo e o nome aparecem na barra superior, como ícone da aba do navegador e no cabeçalho dos relatórios exportados.
            </div>

            {/* Rastro de deslocamento */}
            <p style={{ fontSize: 12, color: 'var(--ios-gray)', textTransform: 'uppercase', letterSpacing: 0.5, margin: '0 4px 12px', fontWeight: 500 }}>
                Mapa — Rastro de deslocamento
            </p>
            <div className="ios-group" style={{ marginBottom: 20 }}>
                <div style={{ padding: '14px 16px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                        <span style={{ fontSize: 15, color: 'var(--ios-label)' }}>Tamanho do rastro</span>
                        <span style={{ fontSize: 15, fontWeight: 600, color: trailLength === 0 ? 'var(--ios-gray)' : '#007aff', minWidth: 32, textAlign: 'right' }}>
                            {trailLength === 0 ? 'Desativado' : `${trailLength} pos.`}
                        </span>
                    </div>
                    <input
                        type="range"
                        min={0} max={15} step={1}
                        value={trailLength}
                        onChange={e => setTrailLength(Number(e.target.value))}
                        style={{ width: '100%', accentColor: '#007aff', cursor: 'pointer' }}
                    />
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: 'var(--ios-gray)', marginTop: 4 }}>
                        <span>Desativado</span>
                        <span>15 posições</span>
                    </div>
                    <div style={{ marginTop: 10, fontSize: 12, color: 'var(--ios-gray)' }}>
                        Número de posições anteriores exibidas como rastro no mapa para veículos em movimento.
                    </div>
                </div>
            </div>

            {/* Botão salvar */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                <button className="ios-btn ios-btn-primary" onClick={salvar} disabled={salvando}>
                    {salvando ? 'Salvando...' : 'Salvar alterações'}
                </button>
                {msg && (
                    <span style={{ fontSize: 13, color: msg.includes('Erro') ? '#ff3b30' : '#34c759', fontWeight: 500 }}>
                        {msg}
                    </span>
                )}
            </div>
        </div>
    );
}

// ── Componente principal ──────────────────────────────────────

const ICONES = {
    status: (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="22,12 18,12 15,21 9,3 6,12 2,12"/>
        </svg>
    ),
    logs: (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
    ),
    usuarios: (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
    ),
    auditoria: (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
    ),
    customizacao: (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
        </svg>
    ),
};

const abas = [
    { key: 'status',      label: 'Status do Sistema' },
    { key: 'logs',        label: 'Log de Conexões'   },
    { key: 'usuarios',    label: 'Usuários'           },
    { key: 'auditoria',   label: 'Auditoria LGPD'    },
    { key: 'customizacao',label: 'Customização'       },
];

export default function Configuracoes({ onFechar, onAtualizar }) {
    const [abaAtiva, setAbaAtiva] = useState('status');

    return (
        <div className="ios-overlay" onClick={onFechar}>
            <div className="ios-sheet" style={{ width: 820, maxWidth: '96vw', maxHeight: '88vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
                {/* Header */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid var(--ios-separator)', flexShrink: 0 }}>
                    <span style={{ fontWeight: 600, fontSize: 17 }}>Configurações</span>
                    <button className="ios-btn ios-btn-gray ios-btn-sm" onClick={onFechar}>Fechar</button>
                </div>

                {/* Abas */}
                <div style={{ display: 'flex', borderBottom: '1px solid var(--ios-separator)', flexShrink: 0, background: 'white' }}>
                    {abas.map(a => {
                        const ativo = abaAtiva === a.key;
                        return (
                            <div key={a.key} onClick={() => setAbaAtiva(a.key)} style={{
                                padding: '11px 18px', cursor: 'pointer', fontSize: 13, fontWeight: ativo ? 600 : 400,
                                color: ativo ? '#007aff' : '#8e8e93',
                                borderBottom: ativo ? '2px solid #007aff' : '2px solid transparent',
                                transition: 'all 0.15s', display: 'flex', alignItems: 'center', gap: 6,
                                userSelect: 'none',
                            }}>
                                <span style={{ opacity: ativo ? 1 : 0.6 }}>{ICONES[a.key]}</span>
                                {a.label}
                            </div>
                        );
                    })}
                </div>

                {/* Conteúdo */}
                <div style={{ flex: 1, overflowY: 'auto', background: 'var(--ios-gray6)' }}>
                    {abaAtiva === 'status' && <AbaStatus />}
                    {abaAtiva === 'logs' && <AbaLogs />}
                    {abaAtiva === 'usuarios' && <AbaUsuarios />}
                    {abaAtiva === 'auditoria'    && <AbaAuditoria />}
                    {abaAtiva === 'customizacao' && <AbaCustomizacao onAtualizar={onAtualizar} />}
                </div>
            </div>
        </div>
    );
}
